import Icon from 'veui/components/Icon'

Icon.register({
  'image-broken': {
    paths: [
      {
        d: 'M704 704H64a32 32 0 01-32-32V128a32 32 0 0132-32h225a32 32 0 010 64H96v480h576V160H435.78l-76.84 153.68 111.69 111.69a32 32 0 016 36.94l-64 128a32 32 0 01-57.24-28.62l53.68-107.37-111.7-111.69a32 32 0 01-6-36.94l96-192A32 32 0 01416 96h288a32 32 0 0132 32v544a32 32 0 01-32 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
